import type { IconProps } from './types';

function Edit02Icon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path
        d="M19.0312 11.5312L12.4688 4.96875L15.2812 2.15625L21.8438 8.71875L19.0312 11.5312Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M19.0312 11.5312L9.1875 21.375H2.625V14.8125L12.4688 4.96875L19.0312 11.5312Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export { Edit02Icon };
